// DropdownNavbar.tsx
import React from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import styled from 'styled-components';

// --- Styled Components ---
export const Nav = styled.nav`
  background: #FFDAC1;
  height: 85px;
  display: flex;
  justify-content: space-between;
  padding: 0.2rem max(calc((100vw - 10000px) / 2), 5rem);
  z-index: 12;
  user-select: none;
`;

export const NavMenu = styled.div`
  display: flex;
  align-items: center;
  margin-right: -24px;

  @media screen and (max-width: 785px) {
    display: none;
  }
`;

export const NavLink = styled(RouterLink)`
  color: #808080;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;

  &:hover {
    color: #000000;
  }

  &.active {
    color: #000000;
  }
`;

export const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const DropdownButton = styled(RouterLink)`
  color: #808080;
  padding: 0 1rem;
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    color: #000000;
  }

  &.active {
    color: #000000;
  }
`;


export const DropdownContent = styled.div`
  display: none;
  position: absolute;
  background-color: #FFDAC1;
  min-width: 250px;
  box-shadow: 0px 8px 16px rgba(0,0,0,0.2);
  z-index: 1;
  flex-direction: column;

  ${DropdownContainer}:hover & {
    display: flex;
  }
`;

export const DropdownLink = styled(RouterLink)`
  color: #808080;
  padding: 12px 16px;
  text-decoration: none;
  display: block;

  &:hover {
    background-color: #ffe0c1;
    color: #000000;
  }
`;

export const NavBtn = styled.nav`
  display: flex;
  align-items: center;
  margin-right: 24px;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const NavBtnLink = styled(RouterLink)`
  border-radius: 4px;
  background: #808080;
  padding: 10px 22px;
  color: #FFFFFF;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  margin-left: 24px;

  &:hover {
    background: #fff;
    color: #000080;
  }
`;